import { gql } from "@apollo/client"

export const GET_STATION_DISTANCE_CONFIGS = gql`
    query getStationDistanceConfigs($filter: StationDistanceConfigFilterInput!, $page: PageInput!) {
        getStationDistanceConfigs(filter: $filter, page: $page) {
            code
            success
            message
            total_count
            station_distance_configs {
                station_distance_id
                from_station_id
                to_station_id
                from_station {
                    id
                    name {
                        en
                        ar
                    }
                    country_details {
                        country_code
                    }
                }
                to_station {
                    id
                    name {
                        en
                        ar
                    }
                    country_details {
                        country_code
                    }
                }
                distance_nm
                is_bidirectional
                effective_from
                effective_to
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                user_audit {
                    created_date
                    created_by
                    modified_date
                    modified_by
                }
            }
        }
    }
`

export const GET_LOCATIONS = gql`
    query SearchLocation($page: PageInput!) {
        searchLocation(page: $page) {
            code
            success
            message
            locations {
                id
                name {
                    en
                    ar
                }
                country_details {
                    country_code
                    country
                    country_ar
                    is_gcc
                }
                port_code
                geo {
                    lat
                    lng
                }
                address {
                    unit_no
                    road_no
                    block_no
                    contact
                    area
                    landmark
                }
            }
            total_count
        }
    }
`

export const STATION_DISTANCE_STATUS = gql`
    query stationDistanceStatus($code: String) {
        stationDistanceStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`